import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import baseUrl from "../../../baseUrl";
import EmptyData from "../EmptyData/EmptyData";
import Spinner from "../../Spinner/Spinner";
import { toast } from "react-toastify";

const ListStudents = () => {
  const adminToken = JSON.parse(localStorage.getItem("EXAMNP:admin-token"));

  const [studentsByBatch, setStudentsByBatch] = useState([]);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const { id } = useParams();

  // for loading studentsByBatch list
  useEffect(() => {
    setLoading(true);
    axios
      .get(`${baseUrl}/admin/get-student-by-batch-id/${id}`, {
        headers: { Authorization: `Bearer ${adminToken}` },
      })
      .then((res) => {
        if (res.data.success === true) {
          setStudentsByBatch(res.data.students);
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [adminToken, id]);

  // handle function for deleting studentsByBatch
  const handleDeleteStudent = (_id) => {
    axios
      .post(
        `${baseUrl}/admin/delete-student/${_id}`,
        {
          _id,
        },
        {
          headers: { Authorization: `Bearer ${adminToken}` },
        }
      )
      .then((res) => {
        setStudentsByBatch(studentsByBatch.filter((item) => item._id !== _id));
        navigate("/admin/batch-details/" + id);
        toast.success(res.data.message);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  return (
    <>
      {loading && <Spinner />}
      {studentsByBatch.length <= 0 ? (
        <EmptyData message="Sorry! studentsByBatch data not found." />
      ) : (
        <table className="table-auto w-full">
          <thead className="text-xs font-semibold uppercase text-gray-400 bg-gray-50">
            <tr>
              <th className="p-2">
                <div className="font-semibold text-left">Reg.No.</div>
              </th>
              <th className="p-2">
                <div className="font-semibold text-left">S.Name</div>
              </th>
              <th className="p-2">
                <div className="font-semibold text-left">S.Email</div>
              </th>

              <th className="p-2">
                <div className="font-semibold text-left">S.Address</div>
              </th>
              <th className="p-2">
                <div className="font-semibold text-left">S.Phone</div>
              </th>

              <th className="p-2">
                <div className="font-semibold text-left">Action</div>
              </th>
            </tr>
          </thead>

          <tbody className="text-sm divide-y divide-gray-100">
            {studentsByBatch.map((student, index) => (
              <tr key={index}>
                <td className="p-2">
                  <div className="mb-4 md:mr-2 md:mb-0">
                    <label className="block mb-2 text-sm font-medium text-blue-600">
                      {student.registrationNumber}
                    </label>
                  </div>
                </td>
                <td className="p-2">
                  <div className="mb-4 md:mr-2 md:mb-0">
                    <label className="block mb-2 text-sm font-medium text-blue-900">
                      <Link to={`/admin/all-students`}>
                        {student.studentName}
                      </Link>
                    </label>
                  </div>
                </td>
                <td className="p-2">
                  <div className="mb-4 md:mr-2 md:mb-0">
                    <label className="block mb-2 text-sm font-medium text-blue-600">
                      {student.studentEmail}
                    </label>
                  </div>
                </td>
                <td className="p-2">
                  <div className="mb-4 md:mr-2 md:mb-0">
                    <label className="block mb-2 text-sm font-medium text-blue-600">
                      {student.studentAddress}
                    </label>
                  </div>
                </td>
                <td className="p-2">
                  <div className="font-medium text-blue-600">
                    {student.studentPhoneNumber}
                  </div>
                </td>

                <td className="p-2">
                  <div className="flex justify-center">
                    <Link to={`/admin/update-student/${student._id}`}>
                      <i className="fa-solid fa-pen-to-square w-8 h-8 pt-2 hover:text-green-600 rounded-full hover:bg-green-100 p-1"></i>
                    </Link>
                    <button
                      onClick={() => {
                        handleDeleteStudent(student._id);
                      }}
                    >
                      <svg
                        className="w-8 h-8 hover:text-red-600 rounded-full hover:bg-red-100 p-1"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                        ></path>
                      </svg>
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      <hr />
    </>
  );
};

export default ListStudents;
